import React 		from 'react';
import ReactDOM from 'react-dom';

import BLComponent from '../core/_BLComponent.jsx';

export default class FeedbackRequest extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Feedback, Suggestions and Requests</h1>
				<h2>Possible Upcoming Features</h2>
				<p>Future updates and other ideas for API that people frequently talk about are listed below. Please note that including these features in the API is <strong>not</strong> guaranteed.</p>
				<ul>
					<li>{`Add PUT /orders/{order_id}/problem endpoint to file/unfile an NPB alert`}</li>
					<li><strike>{`Add POST /orders/{order_id}/drive_thru endpoint to send "Thank You, Drive Thru!" e-mail to a buyer`}</strike></li>
					<li><strike>{`Add GET /item_mapping/{item_type}/{item_no} endpoint to get Part-Color-Code (A.K.A ElementID) of items`}</strike></li>
					<li><strike>{`Add GET /item_mapping/{element_id} endpoint to get BL item_no by Part-Color-Code (A.K.A ElementID)`}</strike></li>
					<li><strike>{`Add GET /items/{item_type}/{item_no}/colors endpoint to get currently known colors of the item`}</strike></li>
					<li><strike>{`Modify PUT /orders/{order_id} to also update "remarks"`}</strike></li>
					<li><strike>{`Add "vat" parameter to GET /items/{item_type}/{item_no}/price to include or exclude VAT from prices`}</strike></li>
				</ul>
				<h2>Bugs &amp; Known Issues</h2>
				<p>Below is a list of common API issues that are acknowledged. We're working on fixing these.</p>
				<ul>
					<li>{`GET /order/{order_id} endpoint can't retrieves PURGED orders`}</li>
				</ul>
			</section>
		);
	}
}